export const currentDateTime = () => {
  const currentDateTime = getCurrentDateTime();
  return currentDateTime;
  // return "2026-11-01 09:00";
};

export const getCurrentDateTime = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  const hours = String(now.getHours()).padStart(2, "0");
  const minutes = String(now.getMinutes()).padStart(2, "0");
  const seconds = String(now.getSeconds()).padStart(2, "0");
  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
};

export const formatRoundTime = (roundTime) => {
  if (!roundTime) return "";

  return new Date(roundTime).toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
  });
};

export const formatRoundDate = (roundDate) => {
  if (!roundDate) return "";
  return roundDate.split(" ")[0];
};
